import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Avatar,
    ButtonBase,
    Button,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

const ICON_BGS = [
    require("../../../images/icons/anchor_rank_1.png"),
    require("../../../images/icons/anchor_rank_2.png"),
    require("../../../images/icons/anchor_rank_3.png")
];

const RANKS = [
    require("../../../images/icons/rank_1.png"),
    require("../../../images/icons/rank_2.png"),
    require("../../../images/icons/rank_3.png")
];

const ICON_HUO = require("../../../images/icons/huo.png");

class AnchorTopItem extends React.Component {

    _onClickAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    render() {
        const { classes, data, avatar, idx } = this.props;
        let ICONBG = ICON_BGS[idx];
        let ICONRK = RANKS[idx];


        return (
            <Grid container direction='column' justify='center' alignItems='center'>
                <Grid container direction='column' justify='center' alignItems='center'>
                    <ButtonBase
                        disableRipple
                        className={classes.buttonBase}
                        style={{
                            backgroundSize: 'cover',
                            backgroundImage: `url(${ICONBG})`,
                            backgroundRepeat: 'no-repeat',
                        }}
                        onClick={() => this._onClickAnchor(data)}
                    >
                        <Avatar src={data.portrait} className={classes.avatar} ></Avatar>
                        <img src={ICONRK} className={classes.iconRank}></img>
                    </ButtonBase>
                </Grid>
                <Grid container justify='center' style={{ marginTop: 8 }}>
                    <Typography style={{ color: '#FFF', fontSize: 13 }}>{data.nickname}</Typography>
                </Grid>
                <Grid container direction='row' justify='center' alignItems='center' style={{ flex: 1, marginTop: 8 }}>
                    <img src={ICON_HUO} className={classes.iconHuo}></img>
                    <Typography style={{ color: '#FFF', fontSize: 11 }}>{data.heat}</Typography>
                </Grid>
                <Grid container justify='center' style={{ marginTop: 8 }}>
                    <ButtonBase
                        disableRipple
                        className={data.isStart ? classes.dy1Button : classes.dyButton}
                        onClick={() => this.props.onClick && this.props.onClick()}
                    >{data.isStart ? '取消关注' : '关注'}</ButtonBase>
                </Grid>
            </Grid >

        );
    }
}

export default withRouter(withStyles((theme) => ({

    avatar: {
        height: 78,
        width: 78,
    },
    iconHuo: {
        height: 15,
        width: 15,
        marginRight: 4,
    },
    iconRank: {
        height: 22,
        width: 22,
        position: 'absolute',
        left: 0,
        top: 10,
    },
    dyButton: {
        minWidth: 60,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        fontSize: 11,
        color: '#FFF'
    },
    dy1Button: {
        minWidth: 60,
        backgroundColor: 'transparent',
        height: 25,
        borderRadius: 12.5,
        color: '#7F708E',
        fontSize: 11,
        border: 'solid 1px #665B70'
    },
    buttonBase: {
        width: 86,
        height: 86,
    }
}))(AnchorTopItem));